// pages/Editor/components/StepRenderer.tsx
import { AutomationStep, ParentStep } from '@/types/automationSteps.ts';
import DragPreviewProvider from '@/pages/Editor/components/tree/DragPreviewProvider.tsx';
import { Box } from '@mantine/core';
import AddStepButton from '@/pages/Editor/components/AddStepButton/AddStepButton.tsx';
import { SiblingParentOption } from '@/pages/Editor/components/tree/types.ts';
import EditorStepCard from '@/pages/Editor/components/EditorStepCard/EditorStepCard.tsx';
import { StepDisabledInfo } from '@/utils/stepUtils.ts';

type Props = {
  step: AutomationStep;
  index: number; // zero-based index within current parent
  parentSteps: ParentStep[]; // chain root -> immediate parent
  isDragPreview: boolean;
  addSiblingParents: SiblingParentOption[];
  isLastStep?: boolean;
  activeConditionIds?: Record<string, string>;
  setActiveConditionIds?: (c: Record<string, string>) => void;
  disabledInfo?: StepDisabledInfo;
  canAdd?: boolean;
  canReorder?: boolean;
};

const StepRenderer = ({
  step,
  index,
  parentSteps,
  isDragPreview,
  addSiblingParents,
  isLastStep = false,
  activeConditionIds,
  setActiveConditionIds,
  disabledInfo,
  canAdd = true,
  canReorder = true,
}: Props) => {
  return (
    <Box mb={'40px'} style={{ position: 'relative' }}>
      <DragPreviewProvider value={isDragPreview}>
        <EditorStepCard
          step={step}
          index={index}
          parentSteps={parentSteps}
          activeConditionIds={activeConditionIds}
          setActiveConditionIds={setActiveConditionIds}
          disabledInfo={disabledInfo}
          canReorder={canReorder}
        />
      </DragPreviewProvider>

      {!isDragPreview && canAdd && (
        <AddStepButton
          addSiblingParents={addSiblingParents}
          contextStep={step}
          alwaysShow={isLastStep}
          activeConditionIds={activeConditionIds}
        />
      )}
    </Box>
  );
};

export default StepRenderer;
